import { CONNECTION_STATE_REFRESHER, IMobizHttpService } from '../core';
import { ModuleWithProviders, NgModule, Optional, Provider, SkipSelf } from '../injection';

import { AXIOS_STATIC_HTTP_CLIENT, axiosStaticHttpClientFactory } from './other/axios-static-http-client.factory';
import { connectionStateRefresherFactory } from './other/connection-state-refresher';
import { ConnectionHelperService } from './services/connection-helper.service';
import { MobizHttpAxiosService } from './services/mobiz-http-axios.service';
import { TokenRefreshService } from './services/token-refresh.service';

@NgModule({})
export class MobizCommonHttpAxiosModule {
  public static readonly PROVIDERS: Provider[] = [
    ConnectionHelperService,
    TokenRefreshService,
    {
      provide: AXIOS_STATIC_HTTP_CLIENT,
      useFactory: axiosStaticHttpClientFactory
    },
    {
      provide: CONNECTION_STATE_REFRESHER,
      useFactory: connectionStateRefresherFactory,
      deps: [
        ConnectionHelperService,
      ],
    },
    {
      provide: IMobizHttpService,
      useClass: MobizHttpAxiosService,
    },
  ];

  constructor(
    @Optional() @SkipSelf() self: MobizCommonHttpAxiosModule | null,
  ) {
    if (self) {
      throw new Error('MobizCommonHttpAxiosModule should only be imported once.');
    }
  }

  public static forRoot(): ModuleWithProviders<MobizCommonHttpAxiosModule> {
    return {
      ngModule: MobizCommonHttpAxiosModule,
      providers: MobizCommonHttpAxiosModule.PROVIDERS,
    };
  }
}
